import { use, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import {
  ContractAdminModel,
  useInvalidateUseStaffGetContractsForCampaign,
  useStaffGetContractsForCampaign,
} from '@urbanx/agx.campaigns.client'
import { NotificationContext } from 'contexts'
import { CampaignUpdatedEvent, NotificationType } from 'types/pushNotifications'

const useContractsList = (): {
  contracts: ContractAdminModel[]
  isLoading: boolean
  invalidateContracts: (campaignId?: string) => Promise<void>
} => {
  const { campaignId } = useParams()
  const notifications = use(NotificationContext)
  const invalidateContractsForCampaign =
    useInvalidateUseStaffGetContractsForCampaign()

  const invalidateContracts = async (id = campaignId) => {
    if (id) await invalidateContractsForCampaign(id)
  }

  useEffect(() => {
    if (!campaignId) return

    const campaignUpdated = async (event: CampaignUpdatedEvent) => {
      if (event.campaignId === campaignId) {
        await invalidateContracts()
      }
    }

    notifications?.registerEvent(
      NotificationType.CampaignUpdatedEvent,
      campaignUpdated,
      [campaignId]
    )
  }, [campaignId, notifications])

  const { data: contracts, isPending } = useStaffGetContractsForCampaign(
    campaignId || '',
    !!campaignId
  )

  return {
    contracts: contracts ?? [],
    isLoading: !!campaignId && isPending,
    invalidateContracts,
  }
}

export default useContractsList
